import React from 'react';
import * as Styles from './UsefulLinks.styles';
import { WhiteCard, Title } from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import { Button, IconArrow } from 'gatorcomponents';

const UsefulLinks = ({ locale, cardsActions }) => (
  <WhiteCard data-testid="home-get-used-to-cards">
    <Styles.ContentWrapper>
      <Title>{locale.title}</Title>
      <Styles.WrapperCards>
        {locale.cards.map(item => (
          <Styles.CardItem key={item.id} data-testid="cardItem">
            {item.icon}

            <Styles.CardContent>
              <Styles.CardTitle>{item.title}</Styles.CardTitle>
              <Styles.CardDescription>{item.description}</Styles.CardDescription>

              <Styles.CardCtaWrapper>
                <Button
                  label={item.cta}
                  variant="text"
                  iconRight={<IconArrow direction="right" color="primaryBlue" />}
                  onClick={cardsActions[item.id]}
                />
              </Styles.CardCtaWrapper>
            </Styles.CardContent>
          </Styles.CardItem>
        ))}
      </Styles.WrapperCards>
    </Styles.ContentWrapper>
  </WhiteCard>
);

export default UsefulLinks;
